export default {"src":"/_next/static/media/slider-btn-right.6d2f6080.svg","height":148,"width":147,"blurWidth":0,"blurHeight":0};